export const resetUserPreferences = (reset) => {
  return {
    type: 'RESET_USER_PREFERENCES',
    payload: reset,
  }
}

export const userPreferencesError = (error) => {
  return {
    type: 'USER_PREFERENCES_ERROR',
    payload: error,
  }
}

export const setUserPreferences = (data) => {
  return {
    type: 'SET_USER_PREFERENCES',
    payload: data,
  }
}
